import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function MarketplaceListingCardSkeleton({
  className,
}: {
  className?: string;
}) {
  return (
    <Card
      className={cn(
        "border-gray-blue-200 flex h-full w-full flex-col gap-0 overflow-hidden rounded-xl border bg-white p-0 shadow-sm",
        className
      )}>
      <Skeleton className="aspect-[16/9] w-full rounded-none sm:aspect-[4/3]" />
      <div className="flex flex-1 flex-col gap-2 px-4 pt-2 pb-4">
        <Skeleton className="h-4 w-32" />
        <div className="space-y-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-4/5" />
        </div>
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-5 w-20" />
      </div>
    </Card>
  );
}
